/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getCountryCode } from "core/location";
// @ts-ignore
import ReactPhoneInput from "react-phone-input-2";
import "./style.less";

interface IPhoneInputBoxProps {
  error: boolean;
  value: any;
  onChange: any;
  autoFocus: boolean;
}

export const PhoneInputBox: React.FC<IPhoneInputBoxProps> = (props) => {
  let containerClass = "react-tel-input ";
  if (props.error) {
    containerClass = containerClass.concat("react-tel-input-error");
  }

  const [currentValue, setCurrentValue] = useState({
    value: props.value || "",
    country: "us",
    isTouched: false,
  });

  const changeHandler = (val: string, country: any) => {
    setCurrentValue({ value: val, country: country.countryCode, isTouched: true });
  };

  useEffect(() => {
    if (!currentValue.isTouched) {
      retrieveCountryCode();
    }
  }, []);

  const retrieveCountryCode = async () => {
    let countryCode;
    try {
      countryCode = await getCountryCode();
      } catch (ignored) {
      countryCode = "us"
    }
    setCurrentValue({ ...currentValue, country: countryCode });
  };

  return (
    <ReactPhoneInput
      {...props}
      value={props.value || currentValue.value}
      country={currentValue.country}
      inputExtraProps={{
        name: "phone",
        required: false,
        enableSearch: true,
      }}
      onChange={props.onChange || changeHandler}
      inputProps={{
        autoFocus: props.autoFocus,
        value: props.value || currentValue.value,
        tabIndex: 1,
      }}
      containerClass={containerClass}
    />
  );
};
